import { useEffect, useRef } from 'react';

// Interrogation périodique consciente de la visibilité.
// Sur mobile, laisser tourner un setInterval quand l'app est en arrière-plan gaspille
// batterie + données et accumule des requêtes obsolètes. Ce hook suspend le polling
// quand l'onglet/app est masqué et relance (avec un fetch immédiat) au retour au premier plan.
export function useVisiblePolling(callback, intervalMs, enabled = true) {
  const cb = useRef(callback);
  cb.current = callback;

  useEffect(() => {
    if (!enabled) return undefined;
    let id = null;
    const tick = () => cb.current();
    const start = () => { if (id == null) id = setInterval(tick, intervalMs); };
    const stop = () => { if (id != null) { clearInterval(id); id = null; } };
    const onVisibility = () => {
      if (document.hidden) stop();
      else { tick(); start(); }
    };

    tick();          // fetch immédiat au montage
    start();
    document.addEventListener('visibilitychange', onVisibility);
    return () => { stop(); document.removeEventListener('visibilitychange', onVisibility); };
  }, [intervalMs, enabled]);
}
